<h4 class="title">User Create</h4>
<button type="button" class="btn btn-primary btn-bg-blue" (click)="cancel()"
    style="float:right;margin-top:-36px;">Back</button>

<div class="card-box" *ngIf="doct.length > 0 && usertype_list.length > 0 && userrole_list.length > 0">
    <div class="row" style="padding: 0px 0px 23px 10px;">
        <div class="col-md-4" [ngClass]="{'dis':form_act}">
            <h5 class="form-lable">User Type:</h5>
            <p-dropdown [options]="usertype_list" [(ngModel)]="usertype" placeholder="Select" optionLabel="y"
                [showClear]="true"></p-dropdown>

        </div>
        <div class="col-md-4" [ngClass]="{'dis':form_act}">
            <h5 class="form-lable">User Name:</h5>
            <input type="text" pInputText [(ngModel)]="user_name" placeholder="User Name">
        </div>
        <div class="col-md-4" [ngClass]="{'dis':form_act}">
            <h5 class="form-lable">User Role:</h5>
            <p-dropdown [options]="userrole_list" [(ngModel)]="user_role" placeholder="Select" optionLabel="y"
                [showClear]="true"></p-dropdown>
        </div>

        <div class="col-md-4" [ngClass]="{'dis':form_act}">
            <h5 class="form-lable">User id:</h5>
            <input type="text" pInputText [(ngModel)]="user_id" placeholder="User id">

        </div>
        <div class="col-md-4" [ngClass]="{'dis':form_act}">
            <h5 class="form-lable">Staff id:</h5>
            <input type="text" pInputText [(ngModel)]="staff_id" placeholder="Staff id">

        </div>
        <div class="col-md-4" [ngClass]="{'dis':form_act}">
            <h5 class="form-lable">Mobile no:</h5>
            <input type="text" pInputText [(ngModel)]="mobile_no" placeholder="Mobile no">

        </div>
        <div class="col-md-4" [ngClass]="{'dis':form_act}">
            <h5 class="form-lable">WhatsApp no:</h5>
            <input type="text" pInputText [(ngModel)]="whatsapp_no" placeholder="WhatsApp no">

        </div>
        <div class="col-md-4" [ngClass]="{'dis':form_act}">
            <h5 class="form-lable">Landline no:</h5>
            <input type="text" pInputText [(ngModel)]="landline_no" placeholder="Landline no">

        </div>
        <div class="col-md-4" [ngClass]="{'dis':form_act}">
            <h5 class="form-lable">Ext no:</h5>
            <input type="text" pInputText [(ngModel)]="ext_no" placeholder="Ext no">

        </div>
        <div class="col-md-4" [ngClass]="{'dis':form_act}">
            <h5 class="form-lable">Office email id:</h5>
            <input type="text" pInputText [(ngModel)]="office_email" placeholder="Office email id">

        </div>
        <div class="col-md-4" [ngClass]="{'dis':form_act}">
            <h5 class="form-lable">Personal email id:</h5>
            <input type="text" pInputText [(ngModel)]="person_email" placeholder="Personal email id">

        </div>
        <div class="col-md-4" [ngClass]="{'dis':form_act}">
            <h5 class="form-lable">Linkedin URL:</h5>
            <input type="text" pInputText [(ngModel)]="linked_url" placeholder="Linkedin URL">

        </div>
        <div class="col-md-4" [ngClass]="{'dis':form_act}">
            <h5 class="form-lable">FB URL:</h5>
            <input type="text" pInputText [(ngModel)]="fb_url" placeholder="FB URL">

        </div>
        <div class="col-md-4" [ngClass]="{'dis':form_act}">
            <h5 class="form-lable">Website:</h5>
            <input type="text" pInputText [(ngModel)]="website" placeholder="Website">

        </div>
        <div class="col-md-6" [ngClass]="{'dis':form_act}">
            <h5 class="form-lable">Current Address:</h5>
            <textarea style="margin-bottom: -5px;" rows="3" cols="30" pInputTextarea
                [(ngModel)]="current_address"></textarea>
            <div class="row">
                <div class="col-md-6">
                    <input type="text" (keypress)=_keyPress($event) pInputText [(ngModel)]="current_box"
                        placeholder="PO Box">
                </div>
                <div class="col-md-6">
                    <input type="text" (keypress)=_keyPress($event) pInputText [(ngModel)]="current_pincode"
                        placeholder="Pincode">
                </div>
            </div>
        </div>
        <div class="col-md-6" [ngClass]="{'dis':form_act}">
            <h5 class="form-lable">Home Address:</h5>
            <textarea style="margin-bottom: -5px;" rows="3" cols="30" pInputTextarea
                [(ngModel)]="home_address"></textarea>
            <div class="row">
                <div class="col-md-6">
                    <input type="text" (keypress)=_keyPress($event) pInputText [(ngModel)]="home_box"
                        placeholder="PO Box">
                </div>
                <div class="col-md-6">
                    <input type="text" (keypress)=_keyPress($event) pInputText [(ngModel)]="home_pincode"
                        placeholder="Pincode">
                </div>
            </div>

        </div>
        <div class="col-md-4" [ngClass]="{'dis':form_act}">
            <h5 class="form-lable">Image:</h5>
            <input type="file" #imgType (change)="fileupload($event)" id="imgfile" accept=".png, .jpg, .jpeg"
                class="form-control" id="city" placeholder="User type icon" style="width: 80%;overflow: hidden;">
            <img *ngIf="logo != undefined" src="{{logo}}" alt=""
                style="width: 40px;height: 40px;float: right;margin-top: -37px;" />

        </div>

        <div class="col-md-12 mt-20">
            <button *ngIf="id == undefined" type="button" class="btn btn-primary" (click)="create()">Create</button>
            <button *ngIf="id != undefined && form_act == false" type="button" class="btn btn-primary"
                (click)="update()">Update</button>
            <button *ngIf="id != undefined && form_act == true" type="button" class="btn btn-primary btn-bg-blue"
                (click)="edit()">Edit</button>
            <button *ngIf="id != undefined && form_act == false" type="button" class="btn btn-danger btn-bg-blue"
                (click)="can()">Cancel</button>
        </div>

    </div>

</div>
<ng-container *ngIf="doct.length > 0 && usertype_list.length > 0 && userrole_list.length > 0 && id != undefined">
    <!-- *ngIf="id != undefined" -->
    <h4 class="title-f">Add Documents</h4>
    <div class="card-box">


        <div class="row" style="padding: 0px 0px 23px 10px;">

            <div class="col-md-4">
                <h5 class="form-lable">Document Type:</h5>
                <p-dropdown [options]="doct" [(ngModel)]="Document_Type" placeholder="Select" optionLabel="y"
                    [showClear]="true"></p-dropdown>
            </div>
            <div class="col-md-4">
                <h5 class="form-lable">Document Name:</h5>
                <input type="text" pInputText [(ngModel)]="Document_Name" placeholder="Document Name">
            </div>
            <div class="col-md-4">
                <h5 class="form-lable">Attachment:</h5>
                <input type="file" #imgType (change)="Documentupload($event)" id="imgfile"
                    accept="application/msword, application/vnd.ms-excel, application/pdf" class="form-control"
                    id="city" placeholder="User type icon">


            </div>
            <div class="col-md-4">
                <h5 class="form-lable">Start date:</h5>
                <p-calendar [showIcon]="true" [(ngModel)]="Start_date" inputId="icon"></p-calendar>
            </div>
            <div class="col-md-4">
                <h5 class="form-lable">End date:</h5>
                <p-calendar [showIcon]="true" [(ngModel)]="End_date" inputId="icon"></p-calendar>
            </div>
            <div class="col-md-12 mt-20">
                <button type="button" *ngIf="Doc_id == undefined" class="btn btn-primary"
                    (click)="create_Doc()">Add</button>
                <button type="button" *ngIf="Doc_id != undefined" style="float: right;" class="btn btn-primary"
                    (click)="update_Doc()">Update</button>

                <!-- <button type="button" *ngIf="Documents_array.length > 0"  style="float: right;" class="btn btn-primary" (click)="create_Doc()">Save</button> -->
                <!-- <button type="button" class="btn btn-primary btn-bg-blue" (click)="cancel()">Cancel</button> -->
            </div>
            <div class="col-md-12 mt-20">

                <p-table [value]="Documents_array" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="5"
                    [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [globalFilterFields]="['type']">

                    <ng-template pTemplate="header">
                        <tr class="thhead">
                            <th>S.No</th>
                            <th>Document Type</th>
                            <th>Document Name</th>
                            <th>Attachment</th>
                            <th>Start date</th>
                            <th>End date</th>
                            <th>Action</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item let-i="rowIndex">
                        <tr class="tdrow">
                            <td>{{i+1}}</td>
                            <td>{{item.Document_Type}}</td>
                            <td>{{item.Document_Name}}</td>
                            <td>
                                <i (click)="goToLink1(item.Document_link)" class="fa fa-file-text"
                                    style="background-color: #fff;color: #fd2c3a;" aria-hidden="true"></i>

                            </td>
                            <td>{{item.Start_date}}</td>
                            <td>{{item.End_date}}</td>
                            <td>
                                <i style="color: #2196f3;" class="fa fa-pencil-square-o" aria-hidden="true"
                                    pTooltip="Edit" (click)="edit_Doc(item,i)"></i>

                                <i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" pTooltip="Delete"
                                    (click)="remove_doc(i)"></i>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>

    </div>

    <h4 class="title">HR reporting line</h4>

    <div class="card-box">
        <div class="row" style="padding: 0px 0px 23px 10px;">
            <div class="col-md-4">
                <h5 class="form-lable">Staff ID:</h5>
                <p-dropdown [options]="usertype_list" [(ngModel)]="HR_staff_id" placeholder="Select" optionLabel="y"
                    [showClear]="true"></p-dropdown>
            </div>
            <div class="col-md-4">
                <h5 class="form-lable">Staff Name:</h5>
                <input type="text" pInputText [(ngModel)]="HR_staff_name" placeholder="Staff name">
            </div>
            <div class="col-md-4">
                <h5 class="form-lable">Role:</h5>
                <input type="text" pInputText [(ngModel)]="HR_staff_role" placeholder="Role">

            </div>
            <div class="col-md-4">
                <h5 class="form-lable">Employee type:</h5>
                <p-dropdown [options]="usertype_list" [(ngModel)]="HR_staff_type" placeholder="Select" optionLabel="y"
                    [showClear]="true"></p-dropdown>
            </div>
            <div class="col-md-4">
                <h5 class="form-lable">Start date:</h5>
                <p-calendar [showIcon]="true" inputId="icon" [(ngModel)]="HR_start_date"></p-calendar>
            </div>
            <div class="col-md-4">
                <h5 class="form-lable">End date:</h5>
                <p-calendar [showIcon]="true" inputId="icon" [(ngModel)]="HR_end_date"></p-calendar>
            </div>
            <div class="col-md-12" style="margin-top: 10px;">

                <div class="card-box">
                    <h4 class="title-f">Add Documents</h4>
                    <div class="row" style="padding: 0px 0px 23px 10px;">

                        <div class="col-md-4">
                            <h5 class="form-lable">Document Type:</h5>
                            <p-dropdown [options]="doct" [(ngModel)]="Document_Type1" placeholder="Select"
                                optionLabel="y" [showClear]="true"></p-dropdown>
                        </div>
                        <div class="col-md-4">
                            <h5 class="form-lable">Document Name:</h5>
                            <input type="text" pInputText [(ngModel)]="Document_Name1" placeholder="Document Name">
                        </div>
                        <div class="col-md-4">
                            <h5 class="form-lable">Attachment:</h5>
                            <input type="file" #imgType (change)="Documentupload1($event)" id="imgfile"
                                accept="application/msword, application/vnd.ms-excel, application/pdf"
                                class="form-control" id="city" placeholder="User type icon">


                        </div>
                        <div class="col-md-12 mt-20">
                            <button type="button" *ngIf="Doc_id1 == undefined" class="btn btn-primary"
                                (click)="adddocuments1()">Add</button>
                            <!-- <button type="button" *ngIf="Doc_id1 != undefined" style="float: right;"
                                class="btn btn-primary" (click)="update_Doc1()">Update</button> -->

                            <!-- <button type="button" *ngIf="Documents_array.length > 0"  style="float: right;" class="btn btn-primary" (click)="create_Doc()">Save</button> -->
                            <!-- <button type="button" class="btn btn-primary btn-bg-blue" (click)="cancel()">Cancel</button> -->
                        </div>
                        <div class="col-md-12 mt-20">
                            <p-table [value]="Documents_array1" styleClass="ui-table-customers" #tt [paginator]="true"
                                [rows]="5" [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]"
                                [showCurrentPageReport]="true"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [globalFilterFields]="['type']">

                                <ng-template pTemplate="header">
                                    <tr class="thhead">
                                        <th>S.No</th>
                                        <th>Document Type</th>
                                        <th>Document Name</th>
                                        <th>Attachment</th>
                                        <th>Action</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item let-i="rowIndex">
                                    <tr class="tdrow">
                                        <td>{{i+1}}</td>
                                        <td>{{item.Document_Type1}}</td>
                                        <td>{{item.Document_Name1}}</td>
                                        <td>
                                            <i (click)="goToLink1(item.Document_link)" class="fa fa-file-text"
                                                style="background-color: #fff;color: #fd2c3a;" aria-hidden="true"></i>

                                        </td>
                                        <td>
                                            <!-- <i style="color: #2196f3;" class="fa fa-pencil-square-o" aria-hidden="true"
                                        pTooltip="Edit" (click)="edit_Doc(item,i)"></i> -->

                                            <i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true"
                                                pTooltip="Delete" (click)="remove_doc1(i)"></i>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-md-12 mt-20">
                <button type="button" *ngIf="HR_id == undefined" class="btn btn-primary"
                    (click)="create_ref()">Add</button>
                <button type="button" *ngIf="HR_id != undefined" class="btn btn-primary"
                    (click)="update_ref()">Update</button>
            </div>
            <div class="col-md-12">

                <div class="col-md-12 mt-20">
                    <p-table [value]="HR_reporting_persons_array" styleClass="ui-table-customers" #tt [paginator]="true"
                        [rows]="5" [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                        [globalFilterFields]="['type']">

                        <ng-template pTemplate="header">
                            <tr class="thhead">
                                <th>S.No</th>
                                <th>Staff ID</th>
                                <th>Staff name</th>
                                <th>Role</th>
                                <th>Employee type</th>
                                <th>Start date</th>
                                <th>End date</th>
                                <th>Documents</th>

                                <th>Action</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-item let-i="rowIndex">
                            <tr class="tdrow">
                                <td>{{i+1}}</td>
                                <td>{{item.HR_staff_id}}</td>
                                <td>{{item.HR_staff_name}}</td>
                                <td>{{item.HR_staff_role}}</td>
                                <td>{{item.HR_staff_type}}</td>
                                <td>{{item.HR_start_date}}</td>
                                <td>{{item.HR_end_date}}</td>
                                <td>
                                    <ng-container *ngFor="let govt_id_pic of item.HR_doct">
                                        <i (click)="goToLink1(govt_id_pic.Document_link1)" class="fa fa-file-text"
                                            style="background-color: #fff;color: #fd2c3a;" aria-hidden="true"></i>
                                    </ng-container>
                                </td>
                                <td>
                                    <i style="color: #2196f3;" class="fa fa-pencil-square-o" aria-hidden="true"
                                        pTooltip="Edit" (click)="edit_ref(item,i)"></i>

                                    <i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" pTooltip="Delete"
                                        (click)="remove_hr_reporting(i)"></i>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>

        </div>

    </div>

    <h4 class="title">Product reporting line</h4>
    <div class="card-box">
        <div class="row" style="padding: 0px 0px 23px 10px;">
            <div class="col-md-4">
                <h5 class="form-lable">Client:</h5>
                <p-dropdown [options]="doct" [(ngModel)]="Pro_Client" placeholder="Select" optionLabel="y"
                    [showClear]="true"></p-dropdown>
            </div>
            <div class="col-md-4">
                <h5 class="form-lable">Product:</h5>
                <p-dropdown [options]="doct" [(ngModel)]="Pro_Product" placeholder="Select" optionLabel="y"
                    [showClear]="true"></p-dropdown>
            </div>
            <div class="col-md-4">
                <h5 class="form-lable">Bucket:</h5>
                <p-dropdown [options]="doct" [(ngModel)]="Pro_Bucket" placeholder="Select" optionLabel="y"
                    [showClear]="true"></p-dropdown>
            </div>
            <div class="col-md-4">
                <h5 class="form-lable">Start date:</h5>
                <p-calendar [showIcon]="true" [(ngModel)]="Pro_start_date" inputId="icon"></p-calendar>
            </div>
            <div class="col-md-4">
                <h5 class="form-lable">End date:</h5>
                <p-calendar [showIcon]="true" [(ngModel)]="Pro_end_date" inputId="icon"></p-calendar>
            </div>
            <div class="col-md-12 mt-20">
                <button type="button" *ngIf="Pro_id == undefined" class="btn btn-primary"
                    (click)="create_Pro()">Add</button>
                <button type="button" *ngIf="Pro_id != undefined" class="btn btn-primary"
                    (click)="update_Pro()">Update</button>
            </div>
            <div class="col-md-12">

                <div class="col-md-12 mt-20">

                    <p-table [value]="product_reporting_array" styleClass="ui-table-customers" #tt [paginator]="true"
                        [rows]="5" [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                        [globalFilterFields]="['type']">

                        <ng-template pTemplate="header">
                            <tr class="thhead">
                                <th>S.No</th>
                                <th>Client</th>
                                <th>Product</th>
                                <th>Bucket</th>
                                <th>Start date</th>
                                <th>End date</th>
    
                                <th>Action</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-item let-i="rowIndex">
                            <tr class="tdrow">
                                <td>{{i+1}}</td>
                                <td>{{item.Pro_Client}}</td>
                                <td>{{item.Pro_Product}}</td>
                                <td>{{item.Pro_Bucket}}</td>
                                <td>{{item.Pro_start_date}}</td>
                                <td>{{item.Pro_end_date}}</td>
                                <td>
                                    <i style="color: #2196f3;" class="fa fa-pencil-square-o" aria-hidden="true"
                                        pTooltip="Edit" (click)="edit_Pro(item,i)"></i>

                                    <i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" pTooltip="Delete"
                                        (click)="remove_Pro(i)"></i>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>
    </div>
</ng-container>